import { cn } from '../../lib/utils';

function Badge({ className, variant = 'default', ...props }) {
  const variants = {
    default: 'bg-brand-orange/15 text-brand-orange',
    secondary: 'bg-brand-green/15 text-brand-green',
    outline: 'border border-[var(--ba-surface-border)] text-[var(--ba-body-text)]',
  };

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold',
        variants[variant],
        className
      )}
      {...props}
    />
  );
}

export { Badge };
